// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4v-0";
export var eligibilityCardNotEligible = "_4v-1";